module.exports = __webpack_public_path__ + "img/广州办公室1.4154f0f4.jpg";